import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RplStorageService } from 'src/app/modules/stp-operations/services/rpl-storage.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-view-reg-certificate',
  templateUrl: './view-reg-certificate.component.html',
  styleUrls: ['./view-reg-certificate.component.scss'],
})
export class ViewRegularCertificateComponent implements OnInit {
  regCandidateId: string | null;
  certificateData: any;
  competent: boolean = false;
  isLoadingData: boolean = false;
  officeText: string;

  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService,
  ) {
    this.regCandidateId =
      this.route.snapshot.queryParamMap.get('regCandidateId');
    if (this.regCandidateId != null) {
      this.getCertificateDataForRegularCandidate();
    }
  }

  ngOnInit(): void {}

  getCertificateDataForRegularCandidate() {
    this.commonService
      .getRegularCertificateByEncryptedId(this.regCandidateId)
      .subscribe({
        next: async (result: any) => {
          this.certificateData = await result;
          this.competent = this.certificateData.isCompetent;

          //#region change office name logic
          let actualAssessDate = this.convertStringToDate(
            this.certificateData.actualAssessDate,
          );

          const firstCutoff = this.convertStringToDate('08-08-2024');
          const secondCutoff = this.convertStringToDate('18-02-2026');

          // Normalize time to avoid timezone/time comparison issues
          actualAssessDate.setHours(0, 0, 0, 0);
          firstCutoff.setHours(0, 0, 0, 0);
          secondCutoff.setHours(0, 0, 0, 0);

          // Logic:
          // Before 08-08-2024 → Prime Minister’s Office
          // 09-08-2024 to 17-02-2026 → Chief Adviser’s Office
          // From 18-02-2026 onward → Prime Minister’s Office

          this.officeText =
            actualAssessDate <= firstCutoff || actualAssessDate >= secondCutoff
              ? 'Prime Minister’s Office'
              : 'Chief Adviser’s Office';

          //#endregion

          this.isLoadingData = true;
        },
        error: (err: any) => {
          console.error('Error fetching certificate data:', err);
          this.isLoadingData = false;
        },
      });
  }

  convertStringToDate(dateStr: string): Date {
    const [day, month, year] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
}
